import CONSTANTS from './constants';

// La entrada "Bot Maker" (abajo, junto a "Bot") NO se filtra con
// `permissions` como el resto: ese modelo viejo de roles no sabe nada del
// interruptor por empresa (`Company.botMakerV5IsActive`) ni del grant
// `bot-maker.view`, así que filtrar por `readBot`/`writeBot` la habría
// mostrado a cualquier cuenta con Bot clásico aunque Bot Maker esté apagado
// — ver la revisión de PR #316 (B1). En su lugar lleva `openAccess: true`
// (bypassa el chequeo de `permissions` en Nav.jsx) y Nav.jsx la retira de la
// lista salvo que `useBotMakerNav()` (src/hooks/useBotMakerNav.js) — que
// consulta `GET /api/auth/me` con el mismo cliente/token que el resto del
// host y cachea el resultado por sesión — confirme que `navigation` incluye
// `bot-maker.view`. Ese `/me` vive en la pasarela nueva (apps/server), no en
// el REST legado (404 ahí), así que el hook lo pide con
// REACT_APP_AGENT_GATEWAY_URL cuando está definida en vez de getRestApiUrl().
//
// "Inicio" (primera entrada, ruta `/inicio`) es la pantalla de tareas para
// agentes humanos. Tampoco se filtra con `permissions`: lleva `openAccess` y
// Nav.jsx la muestra solo cuando `canSeeInicio(user.data)`
// (views/dashboard/inicio/access.js), la misma regla del guard de la ruta.
// La entrada de `/dashboard` (antes "Inicio", mostrada como "Dashboard") se
// llama ahora "Resumen" y la ve exactamente la misma gente que antes.
const links = [
  {
    routes: ["/inicio"],
    icon: "BsHouseDoor",
    name: "Inicio",
    openAccess: true,
    permissions: [],
  },
  {
    routes: ["/dashboard"],
    icon: "BsSpeedometer2",
    name: "Resumen",
    permissions: ["readCompany", "writeCompany"],
    superadminOnly: true,
    allowedCompanyIds: ["675dbda724aa9a000835cd92", "5ed824990274390007afcc70", "678728e824aa9a0009c9707e", "68645f238e6d01000893892d"],
  },
  {
    routes: ["/chat"],
    icon: "BsChatLeftFill",
    name: "Chat",
    permissions: ["readChat", "agent"],
  },
  {
    routes: ["/boards", "/board"],
    icon: "BsKanban",
    name: "Boards",
    permissions: ["readChat", "agent"],
  },
  {
    routes: ["/contacts"],
    icon: "BsPeople",
    name: "Contactos",
    permissions: ["agent"],
  },
  {
    routes: [
      CONSTANTS.MULTIMEDIA_ROUTE,
      CONSTANTS.ALBUM_ROUTE,
      CONSTANTS.SUBALBUM_ROUTE,
    ],
    icon: "BsImages",
    name: "Multimedia",
    permissions: ["readMultimedia", "writeMultimedia"],
  },
  {
    routes: [
      CONSTANTS.QUICK_ANSWERS_ROUTE,
      CONSTANTS.QUICK_ANSWERS_ACTION_ROUTE,
    ],
    icon: "BsLightning",
    name: "Respuestas",
    permissions: ["readQuickAnswers", "writeQuickAnswers"],
  },
  {
    routes: ["/users", "/users/new"],
    icon: "BsPersonGear",
    name: "Equipo",
    permissions: ["readUsers", "writeUsers"],
  },
  {
    routes: ["/bot"],
    icon: "BsRobot",
    name: "Bot",
    permissions: ["readBot", "writeBot"],
  },
  {
    routes: ["/bot-maker"],
    icon: "BsStars",
    name: "Bot Maker",
    // Ver el comentario al inicio del archivo: gating real vía
    // useBotMakerNav(), no permissions.
    // La ruta la sirve la otra app (dashboard-next): Nav.jsx llega a ella con
    // una carga completa de página — ver utils/zoneNavigation.js.
    openAccess: true,
    permissions: [],
  },
  {
    routes: ["/broadcast/table"],
    icon: "BsMegaphone",
    name: "Campañas",
    permissions: ["campaigns"],
  },
  {
    routes: ["/analytics"],
    icon: "BsTrophy",
    name: "Estadísticas",
    permissions: ["readAnalytics"],
  },
  {
    routes: ["/spaces", "spaces/new"],
    icon: "BsWhatsapp",
    name: "Canales",
    permissions: ["readSpaces", "writeSpaces"],
  },
  {
    routes: [
      "/config",
      "/config/new-tag",
      "/config/new-rol",
      "/config/new-datasheet",
      "/config/edit-plan",
      "/config/edit-card",
      "/config/album",
    ],
    icon: "BsGear",
    name: "Configuración",
    permissions: [
      "readCompany",
      "writeCompany",
      "readPayments",
      "writePayments",
      "readTags",
      "writeTags",
      "readRols",
      "writeRols",
      "readDataSheetConfiguration",
      "writeDataSheetConfiguration",
    ],
  },
  {
    routes: ["/account", CONSTANTS.UPDATE_SUBSCRIPTION_ROUTE],
    icon: "BsPersonBadge",
    name: "Cuenta",
    permissions: [
      "readCompany",
      "writeCompany",
      "readPayments",
      "writePayments"
    ],
  },
  {
    routes: ["/help"],
    icon: "BsQuestionCircle",
    name: "Ayuda",
    permissions: ["readCompany", "writeCompany"],
  },
];

export default links;
